import IExtendedUser = Authorization.IExtendedUser;
import * as _ from "lodash";
import { PermissionLevels } from '../enums';

export class ExtendedUser implements IExtendedUser {
    public Id: number;
    public FirstName: string;
    public LastName: string;
    public Email: string;
    public Company: string;
    public Address: string;
    public City: string;
    public State: string;
    public ProjectsCount: number;
    public Phone: string;
    public History: string;
    public Logo: string;
    public CompanyLogo: string;
    public IsInactive: boolean;
    public LastLogin: Date;
    public PermissionId: number;
    public DefaultMunicipalityId: number;
    public DefaultCityId: number;
    public SkipDefaultCityDialog: boolean;
    public AcknowledgedOn: Date;
    public IsTrial: boolean;
    public ProjectsCountAvailable: number;
    public LevelPermission: number;
    public Name: string;
    public Url: string;
    public EditUrl: string;

    constructor(userData: IExtendedUser) {
        Object.assign(this, _.pick(userData, [
            "Id",
            "FirstName",
            "LastName",
            "Email",
            "Company",
            "Address",
            "City",
            "State",
            "ProjectsCount",
            "Phone",
            "History",
            "Logo",
            "CompanyLogo",
            "IsInactive",
            "LastLogin",
            "PermissionId",
            "DefaultMunicipalityId",
            "DefaultCityId",
            "SkipDefaultCityDialog",
            "AcknowledgedOn",
            "IsTrial",
            "ProjectsCountAvailable",
            "LevelPermission",
            "Name",
            "Url",
            "EditUrl"
        ]));
    }

    public hasRole(permissionLevel: PermissionLevels) {
        return this.PermissionId === permissionLevel;
    }
}

export function ExtendedUserFactory(data: IExtendedUser) {
    return new ExtendedUser(data);
}
